import { GET_SCHEDULE_HOME, SET_DOCUMENT_ACKNOWLEDGE } from './home.constant';

const initialState = {
  schedule: null,
  acknowledge: false,
};

export const homeReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case GET_SCHEDULE_HOME.SUCCESS:
      return {
        schedule: payload,
        acknowledge: payload.acknowledge,
      };

    case SET_DOCUMENT_ACKNOWLEDGE.START:
      return {
        ...state,
        acknowledge: true,
      };

    case SET_DOCUMENT_ACKNOWLEDGE.SUCCESS:
      return {
        ...state,
        acknowledge: payload.value,
      };

    case SET_DOCUMENT_ACKNOWLEDGE.ERROR:
      return {
        ...state,
        acknowledge: false,
      };

    default:
      return state;
  }
};
